import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../components/Hyperlink';
import { getPageName } from '../../utils/pageName';
import { Connect } from './NavSignUpButtonContainer';

type Props = {
  userHasStartedToSearch: boolean;
};

export class RawNavSignupButton extends React.Component<Props> {
  sourcePage: string = getPageName();

  render() {
    // if search has started from Home page, sourcePage needs to be changed
    if (this.props.userHasStartedToSearch) {
      this.sourcePage = 'Search';
    }
    return (
      <Hyperlink
        className="nav__item button brand nav__button"
        href={`/inscription?source=header&sourcePage=${this.sourcePage}`}
      >
        <FormattedMessage id="navigation/signup/NavSignupButton.tsx/1" />
      </Hyperlink>
    );
  }
}

export const NavSignupButton = Connect(RawNavSignupButton);
